import { Card, CardBody, Col, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultPaginations, Href } from "../../../../Constant";
import { DEFAULT_PAGINATIONS } from "../../../../Data/Bonus Ui/Paginations";

const DefaultPagination = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={DefaultPaginations} span={DEFAULT_PAGINATIONS} />
        <CardBody>
          <Pagination className="pagination-primary pagin-border-primary" aria-label="Page navigation example">
            <PaginationItem><PaginationLink href={Href} previous>Previous</PaginationLink></PaginationItem>
            <PaginationItem><PaginationLink href={Href}>1</PaginationLink></PaginationItem>
            <PaginationItem><PaginationLink href={Href}>2</PaginationLink></PaginationItem>
            <PaginationItem><PaginationLink href={Href}>3</PaginationLink></PaginationItem>
            <PaginationItem><PaginationLink href={Href} next>Next</PaginationLink></PaginationItem>
          </Pagination>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultPagination;
